<template>
  <div class="h-toolbarBg">
    <ejs-toolbar>
      <e-items>
        <e-item v-if='btns.refresh' prefixIcon='icon hero-icon hero-icon-refresh' :tooltipText='$t("Common.refresh")' :click='buttonClk' operate='refresh'></e-item>
        <e-item v-if='btns.add' prefixIcon='icon hero-icon hero-icon-add' :tooltipText='$t("NSMF.add")' :click='buttonClk' operate='add'></e-item>
        <e-item v-if='btns.delete' prefixIcon='icon hero-icon hero-icon-remove' :tooltipText='$t("NSMF.delete")' :click='buttonClk' operate='delete'></e-item>
      </e-items>
    </ejs-toolbar>
  </div>
</template>

<script>
export default {
  name: 'SliceProfileMenu',
  data() {
    return {
      btns: {
        refresh: true,
        add: true,        
        delete: true,      
      },
    };
  },
  mounted() {
  },
  methods: {
    buttonClk(args) {
      this.$emit('methodEnum', args.item.operate);
    },
  },
};
</script>
